import styled from 'styled-components';

export const Container = styled.div(
  props => `
  background: ${props.theme.colors.goWhite.base};
  border-top: 1px solid ${props.theme.colors.goBrandBlue.light}
`,
);

export const InnerWrap = styled.div(
  props => `
  max-width: 120rem;
  width: 100%;
  height: 100%;
  max-width: 120rem;
  margin: 0 auto;
  padding: ${props.theme.spacing.large} 0;
`,
);

export const ImageContainer = styled.div(
  props => `
  width: 4.8rem;
  height: 4.8rem;
  border-radius: 50%;
  background: ${
    props.imagePresent ? props.theme.colors.downriver.base : props.theme.colors.ash.medium
  };
  border: ${props.imagePresent ? 'none' : `0.2rem solid ${props.theme.colors.downriver.light}`};
  z-index: ${props.theme.misc.zIndex.xxsmall};
  display: flex;
  align-items: center;
  justify-content: center;
`,
);

export const ContentWrap = styled.div(
  props => `
  display: flex;
`,
);

export const ContentTextWrapper = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`,
);

export const FriendsStayedTextContainer = styled.div(
  props => `
  padding: ${props.theme.spacing.xsmall} ${props.theme.spacing.large} ${
    props.theme.spacing.xsmall
  } 3.5rem;
  transform: translateX(-20%);
  background: ${props.background || 'linear-gradient(to right, #1ad4ff, #00acff)'};
  color: ${props.theme.colors.goWhite.base};
  display: flex;
  align-items: center;
  border-radius: 1.5rem;
`,
);

export const FriendsStayedText = styled.span(
  props => `
  margin: 0.2rem 0 0 0; // font face idiosyncrasy
  color: ${props.textColor || props.theme.colors.goWhite.base};
  background: ${props.backgroundColor || 'linear-gradient(to right, #1ad4ff, #00acff)'};
`,
);

export const FriendPersuasionText = styled.div(
  props => `
  font-weight: bold;
  color: ${props.textColor || props.theme.colors.downriver.base};
  background: ${props.backgroundColor || props.theme.colors.goWhite.base};
`,
);
